import React, { useState, useEffect } from 'react'
import '../../components/kyc/kycStyle.css'
import {
  API_ERROR_MESSAGE,
  INVALID_ID_WARNING,
  PRICELIST,
  SPIDER_SEARCH_OPTIONS,
} from '../../utils/Constants'
import SearchBySelect from '../../components/form/SearchBySelect/SearchBySelect'
import FormInput from '../../components/form/FormInput/FormInput'
import FooterButtons from '../../components/form/FooterButtons/FooterButtons'
import ScreenLayout from '../../components/layouts/ScreenLayout'
import KycButton from '../../components/form/Button/Button'
// import { handleSpiderCompanyDownloadReport } from '../../api/Spider/spiderCompany'
// import { handleSpiderConsumerDownloadReport } from '../../api/Spider/spiderConsumer'
// import { handleSpiderTrustDownloadReport } from '../../api/Spider/spiderTrust'
import NewAndCloseButtons from '../../components/form/NewAndCloseButtons/NewAndCloseButtons'
import TableDataSpiderCompanies from '../../components/SpiderSearch/TableDataSpiderCompanies'
import TableDataSpiderConsumers from '../../components/SpiderSearch/TableDataSpiderConsumers'
import TableDataSpiderTrusts from '../../components/SpiderSearch/TableDataSpiderTrusts'
import TableDataPropertyCounts from '../../components/SpiderSearch/TableDataPropertyCounts'
import Disclaimer from '../../components/BridgingFinance/Disclaimer'
import { useMutation } from 'react-query'
import { getUserInfo } from '../../api/dots/getUserInfo'
import {
  FullTitle,
  PropertyCount,
  spiderPropertyCounts,
  spiderSearch,
} from '../../api/Spider'
import { Spinner } from 'react-bootstrap'
import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer'
import { NationalDeedsReport } from '../../components/DeedsOfficeSearches/NationalDeedsReport'
import moment from 'moment'
import './SpiderSearch.css'
import { HiPrinter } from 'react-icons/hi'
import { RxCross2 } from 'react-icons/rx'
import { validateIdNumber } from '../../utils/Validation'
import Alert from '../../components/form/Alerts/BasicAlert'

interface SpiderSearchProps {
  setIsError: (value: boolean) => void
  setErrorMessage: (value: string) => void
  setShow: (value: boolean) => void
  initialState: { [key: string]: any }
  setInitialState: React.Dispatch<React.SetStateAction<any>>
}
type spiderCompany = {
  businessName?: string
  registrationNumber?: string
  enquiryId?: string
  enquiryResultId?: string
  erfNo?: string
  streetNo?: string
  address?: string
  suburb?: string
  municipality?: string
}
type spiderTrust = {
  trustNumber: string
  trustName: string
  enquiryId: string
  enquiryResultId: string
}
type spiderConsumer = {
  forenames: string
  lastName: string
  initials: string
  identityNumber: string
  enquiryId: string
  enquiryResultId: string
  reference?: string
}
const defaultSpiderConsumer: spiderConsumer = {
  forenames: '',
  lastName: '',
  initials: '',
  identityNumber: '',
  enquiryId: '',
  enquiryResultId: '',
}
const defaultSpiderTrust: spiderTrust = {
  trustName: '',
  trustNumber: '',
  enquiryId: '',
  enquiryResultId: '',
}

export const SpiderSearch: React.FC<SpiderSearchProps> = ({
  setIsError,
  setErrorMessage,
  setShow,
  setInitialState,
  initialState,
}) => {
  const [lastName, setLastName] = useState('')
  const [businessName, setBusinessName] = useState('')
  const [trustName, setTrustName] = useState('')
  const [trustNumber, setTrustNumber] = useState('')
  const [forenames, setForenames] = useState('')
  const [registrationNumber, setRegistrationNumber] = useState('')
  const [identityNumber, setIdNumber] = useState('')
  const [selectedTrustNumber, setSelectedTrustNumber] = useState('')
  const [selectedCompanyNumber, setSelectedCompanyNumber] = useState('')
  const [reference, setReference] = useState('')
  const [initials, setInitials] = useState('')
  const [titleType, setTitleType] = useState<'FULL' | 'SECTIONAL'>('FULL')
  const [searchBySelectedOption, setSearchBySelectedOption] = useState(
    SPIDER_SEARCH_OPTIONS.searchBy[0].value as string,
  )
  const updateInitialState = () => {
    setInitialState({
      ...initialState,
      sanctionScreening: {
        lastName: lastName,
        forenames: forenames,
        initials: initials,
        reference: reference,
        identityNumber: identityNumber,
        businessName: businessName,
        registrationNumber: registrationNumber,
        searchBySelectedOption: searchBySelectedOption,
      },
    })
  }

  // const handleSpiderConsumerLoadReportParams = {
  //   SpiderConsumer,
  //   setShowProgress,
  //   setIsError,
  //   setErrorMessage,
  //   setReportId,
  // }
  // const handleSpiderCompanyLoadReportParams = {
  //   SpiderCompany,
  //   setShowProgress,
  //   setIsError,
  //   setErrorMessage,
  //   setReportId,
  // }
  // const handleSpiderTrustLoadReportParams = {
  //   SpiderTrust,
  //   setShowProgress,
  //   setIsError,
  //   setErrorMessage,
  //   setReportId,
  // }

  const handleBack = () => {
    //todo: handle back on second step for companies and trusts
    resetSearch()
  }
  const handleStartOver = () => {
    // setSearchBySelectedOption(SPIDER_SEARCH_OPTIONS.searchBy[0].value)
    resetSearch()
    resetPropertyCounts()
    setRegistrationNumber('')
    setReference('')
    setIdNumber('')
    setTrustName('')
    setTrustNumber('')
    setBusinessName('')
    setForenames('')
    setLastName('')
    setInitials('')
  }
  useEffect(() => {
    resetSearch()
    resetPropertyCounts()
    setRegistrationNumber('')
    setReference('')
    setIdNumber('')
    setTrustName('')
    setTrustNumber('')
    setBusinessName('')
    setForenames('')
    setLastName('')
    setInitials('')
  }, [searchBySelectedOption])

  const {
    mutate: getUser,
    data: userInformation,
    isLoading: isLoadingUser,
  } = useMutation('userInformation', getUserInfo, {
    onError: (err) => {
      setIsError(true)
      setErrorMessage(API_ERROR_MESSAGE)
    },
  })
  const {
    mutate: search,
    data: results,
    isLoading: isSearching,
    reset: resetSearch,
  } = useMutation('spider-search-trusts', spiderSearch, {
    onSuccess: () => {
      console.log(results, 'results in spiderSearch.tsx')
    },
    onError: (error: Error) => {
      setIsError(true)
      setErrorMessage(API_ERROR_MESSAGE)
    },
  })

  const handleSpiderSearch = () => {
    updateInitialState()
    const missing = []
    getUser()
    if (searchBySelectedOption === 'COMPANY') {
      if (!businessName) missing.push('Company Name')
    } else if (
      searchBySelectedOption === 'INDIVIDUAL' &&
      (identityNumber === '' || identityNumber?.trim() === '')
    ) {
      if (!identityNumber) missing.push('ID number / Passport')
      return validateIdNumber(identityNumber!)
    } else if (searchBySelectedOption === 'TRUST') {
      if (!trustName) missing.push('Trust name')
      // if (!trustNumber) missing.push('Trust number')
    }
    if (missing.length > 0) {
      alert('Please fill in the following fields: ' + missing.join(', '))
      return
    }
    if (searchBySelectedOption === 'TRUST') {
      if (trustName && !trustNumber) {
        return searchPropertyCounts({
          name: trustName,
          type: 'trust',
        })
      }
      return search({
        trustName,
        trustNo: trustNumber,
        reference,
        type: 'trust',
      })
    }
    if (searchBySelectedOption === 'INDIVIDUAL')
      return search({
        idNo: identityNumber,
        reference,
        type: 'consumer',
      })
    if (searchBySelectedOption === 'COMPANY')
      if (businessName && !registrationNumber) {
        return searchPropertyCounts({
          name: businessName,
          type: 'company',
        })
      }
    return search({
      companyName: businessName,
      companyID: registrationNumber,
      reference,
      type: 'company',
    })
  }

  const {
    mutate: searchPropertyCounts,
    data: propertyCounts,
    isLoading: isLoadingPropertyCounts,
    reset: resetPropertyCounts,
  } = useMutation('spider-property-counts', spiderPropertyCounts, {
    onError: () => {
      setIsError(true)
      setErrorMessage(API_ERROR_MESSAGE)
    },
  })

  const onCountRowClick = (row: PropertyCount) => {
    if (searchBySelectedOption === 'TRUST') {
      setSelectedTrustNumber(row.ownerIDNo)
      return search({
        trustName: row.owner,
        trustNo: row.ownerIDNo,
        reference,
        type: 'trust',
      })
    }

    if (searchBySelectedOption === 'COMPANY') {
      setSelectedCompanyNumber(row.ownerIDNo)
      return search({
        companyName: row.owner,
        companyID: row.ownerIDNo,
        reference,
        type: 'company',
      })
    }
  }

  const getOwnerType = () => {
    if (searchBySelectedOption === 'COMPANY') return 'company'
    if (searchBySelectedOption === 'INDIVIDUAL') return 'consumer'
    return 'trust'
  }

  const getTitleBasedOnType = (titleType: string) => {
    if (titleType === 'INDIVIDUAL')
      return `Search results for properties owned by ID Number Like "${identityNumber}"`
    if (titleType === 'COMPANY')
      return `Search results for properties owned by Company With ${
        registrationNumber ? 'Registration Number' : 'Company Name'
      } Like "${registrationNumber || businessName}"`
    if (titleType === 'TRUST')
      return `Search results for properties owned by Trust with Name Like "${trustName}"`
    return ''
  }

  return (
    <>
      <ScreenLayout
        headerText={'National Deed Search'}
        subHeaderText={
          'You are requesting a search for all properties in South Africa which are owned by a person, trust or company.'
        }
        price={PRICELIST.SPIDER_SEARCH}
      >
        {
          <>
            {isLoadingPropertyCounts && (
              <>
                <div className="spinner-container">
                  <Spinner
                    as="span"
                    animation="border"
                    variant="dark"
                    role="status"
                    aria-hidden="true"
                  ></Spinner>
                  <span> </span>
                </div>
              </>
            )}
            {isSearching && (
              <>
                <div className="spinner-container">
                  <Spinner
                    as="span"
                    animation="border"
                    variant="dark"
                    role="status"
                    aria-hidden="true"
                  ></Spinner>
                  <span> </span>
                </div>
              </>
            )}
            {propertyCounts && (
              <p className="lightGreyText">
                Please reset your search to enable the dropdown and enable
                another search.
              </p>
            )}
            <SearchBySelect
              className="mb-2"
              onChangeHandler={setSearchBySelectedOption}
              options={SPIDER_SEARCH_OPTIONS.searchBy}
              disabled={propertyCounts}
            />
            {searchBySelectedOption === 'INDIVIDUAL' && (
              <>
                <FormInput
                  onChangeHandler={setIdNumber}
                  placeHolderText="ID number / Passport"
                  required
                  value={identityNumber}
                  className="mb-2 custom-input"
                />
                {identityNumber && !validateIdNumber(identityNumber) && (
                  <Alert variant="danger" text={INVALID_ID_WARNING} />
                )}
              </>
            )}
            {searchBySelectedOption === 'COMPANY' && (
              <>
                <FormInput
                  onChangeHandler={setBusinessName}
                  placeHolderText="Company name"
                  required
                  value={businessName}
                  className="mb-2 custom-input"
                />
                <FormInput
                  onChangeHandler={setRegistrationNumber}
                  placeHolderText="Registration number (optional)"
                  value={registrationNumber}
                  className="mb-2 custom-input"
                />
              </>
            )}
            {searchBySelectedOption === 'TRUST' && (
              <>
                <FormInput
                  onChangeHandler={setTrustName}
                  placeHolderText="Trust name"
                  required
                  value={trustName}
                  className="mb-2 custom-input"
                />
                <FormInput
                  onChangeHandler={setTrustNumber}
                  placeHolderText="Trust number"
                  value={trustNumber}
                  className="mb-2 custom-input"
                />
              </>
            )}
            <FormInput
              onChangeHandler={setReference}
              placeHolderText="Search reference (optional)"
              required
              value={reference}
              className="mb-2 custom-input"
            />
            <div className="footer-btns">
              {!propertyCounts ? (
                <FooterButtons
                  setShow={setShow}
                  handleSearch={handleSpiderSearch}
                  isLoading={isSearching || isLoadingPropertyCounts}
                />
              ) : (
                <KycButton
                  children="Reset Search"
                  onClick={resetPropertyCounts}
                />
              )}
            </div>
          </>
        }
        {results && (
          <ResultsTitle title={getTitleBasedOnType(searchBySelectedOption)}>
            <PDFDownloadLink
              document={
                <NationalDeedsReport
                  userInfo={userInformation}
                  fullTitles={results?.fullTitle || []}
                  sectionalTitles={results.sectionalTitle || []}
                  requestedDate={moment().toISOString()}
                  ownerType={getOwnerType()}
                  propertyType={titleType.toLowerCase() as 'full' | 'sectional'}
                  companyName={businessName}
                  registrationNo={
                    selectedCompanyNumber
                      ? selectedCompanyNumber
                      : registrationNumber
                  }
                  trustName={trustName}
                  trustNo={
                    selectedTrustNumber ? selectedTrustNumber : trustNumber
                  }
                />
              }
            >
              <HiPrinter size={18} />
            </PDFDownloadLink>
            <RxCross2 size={18} color="black" onClick={() => handleBack()} />
          </ResultsTitle>
        )}
        {propertyCounts && !results && (
          <>
            <TableDataPropertyCounts
              title={`Search results for properties owned by Trust with Name Like "${trustName}"`}
              results={propertyCounts}
              onFullTitleRowClick={onCountRowClick}
              onSectionalTitleRowClick={onCountRowClick}
              onClose={() => resetPropertyCounts()}
            />
          </>
        )}
        {results && searchBySelectedOption === 'COMPANY' && (
          <>
            <TableDataSpiderCompanies
              // showProgress={showProgress}
              title={`Search results for properties owned by Company Name Like "${businessName}"`}
              results={results}
              // setSpiderCompany={setSpiderCompany}
            />
            <NewAndCloseButtons
              handleAction={handleStartOver}
              handleClose={setShow}
            />
          </>
        )}
        {results && searchBySelectedOption === 'INDIVIDUAL' && (
          <>
            <TableDataSpiderConsumers
              // showProgress={showProgress}
              // title={`Search results for properties owned by ID Number Like "${identityNumber}"`}
              onToggle={(titleType: 'FULL' | 'SECTIONAL') =>
                setTitleType(titleType)
              }
              results={results}
            />
            <NewAndCloseButtons
              handleAction={handleStartOver}
              handleClose={setShow}
            />
          </>
        )}
        {results && searchBySelectedOption === 'TRUST' && (
          <>
            <TableDataSpiderTrusts
              // showProgress={showProgress}
              title={`Search results for properties owned by Trust Name Like "${trustName}"`}
              results={results}
            />
            <NewAndCloseButtons
              handleAction={handleStartOver}
              handleClose={setShow}
            />
          </>
        )}
      </ScreenLayout>
    </>
  )
}
export default SpiderSearch

type ResultsTitleProps = {
  title: string
  children: React.ReactNode
}
const ResultsTitle = (props: ResultsTitleProps) => {
  const { title, children } = props
  return (
    <div className="national-deeds-result-title-container">
      <h3 className="national-deeds-result-title">{title}</h3>
      <div className="national-deeds-buttons">{children}</div>
    </div>
  )
}
